import { render, staticRenderFns } from "./lab.vue?vue&type=template&id=2bd441ea"
import script from "./lab.vue?vue&type=script&lang=js"
export * from "./lab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports